<div class="container-fluid p-3">
  <!-- Header Section -->
  <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-1">
          IP Valuation
        </h4>
        <h5 class="text-primary">[{{ payload?.proposal_name }}]</h5>
        <div class="status-badge">
          <span class="badge" [ngClass]="{
              'bg-secondary': stepDetails?.step_status == 0,
              'bg-success': stepDetails?.step_status == 'approved',
              'bg-warning': stepDetails?.step_status == 'recommended',
              'bg-info': stepDetails?.step_status == 'initiated'
            }">
            {{
            stepDetails?.step_status == 0
            ? "INITIATION PENDING"
            : (stepDetails?.step_status | uppercase)
            }}
          </span>
        </div>
      </div>

      <div class="action-buttons">
        <button class="btn btn-outline-secondary me-2" (click)="generatePDF()">
          <i class="pi pi-file-pdf me-1"></i> PDF
        </button>

        <ng-container *ngIf="stepDetails?.step_status == 'approved'">
          <button class="btn btn-outline-primary me-2" (click)="goToNextStep()">
            Next <i class="pi pi-angle-right ms-1"></i>
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.can_edit||(stepDetails?.step_status != 'approved' && userID == 6)">
          <button class="btn btn-primary me-2" (click)="routeConfig.emit({isRouteConfig: true})" [disabled]="challengeForm?.invalid
            ">
            <i class="pi pi-save me-1"></i> Save/Forward/Route Config
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_initiator">
          <button class="btn btn-success" (click)="IRA.emit('Initiate')">
            <i class="pi pi-play me-1"></i> Initiate
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_approver">
          <button class="btn btn-success" (click)="IRA.emit('Approve')">
            <i class="pi pi-check-circle me-1"></i> Approve
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_recommender">
          <button class="btn btn-info" (click)="IRA.emit('Recommend')">
            <i class="pi pi-thumbs-up me-1"></i> Recommend
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="my-3" />

  <!-- Main Form Content -->
  <div class="form-wrapper">
    <ng-container>
      <form [formGroup]="challengeForm" class="proposal-form-container mb-2" (ngSubmit)="onSubmit()">
        <div class="form-container">

          <div class="collapsible-section">
            <div class="collapsible-header" (click)="toggleSection('challengeForm')">
              <h3 class="section-title">
                Challenge Form
                <i class="pi ms-2"
                  [ngClass]="expandedSections['challengeForm'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
              </h3>
            </div>

            <div class="collapsible-body" *ngIf="expandedSections['challengeForm']">
              <div class="collapsible-section">
                <div class="collapsible-header" (click)="toggleSection('nodal')">
                  <h3 class="section-title">
                    Nodal & Coordinating Agency
                    <i class="pi ms-2"
                      [ngClass]="expandedSections['nodal'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                  </h3>
                </div>

                <div class="collapsible-body" *ngIf="expandedSections['nodal']">
                    <div class="form-row">
                      <b for="coordinated_agency" class="form-label-left">Coordinating Agency <b
                          class="text-warning">*</b></b>
                      <div class="form-field-right">
                        <p-dropdown [options]="unitList" formControlName="coordinated_agency" optionValue="id"
                          optionLabel="name" placeholder="Select a Directorate" class="w-100"
                          (onChange)="onUnitChange($event)" [filter]="true" filterBy="name" appendTo="body"  [readonly]="true">
                        </p-dropdown>
                      </div>
                    </div>
                    <div class="form-row">
                      <b for="nodal_officer" class="form-label-left">Nodal Officer <b class="text-warning">*</b></b>
                      <div class="form-field-right">
                        <p-dropdown [options]="userList" formControlName="nodal_officer" optionValue="id"
                          optionLabel="first_name" placeholder="Select a User" class="w-100"
                          (onChange)="onUserChange($event)" [filter]="true" filterBy="first_name" appendTo="body" [readonly]="true">
                        </p-dropdown>
                      </div>
                    </div>

                    <div class="form-row">
                      <b for="organisation" class="form-label-left">Organisation<b class="text-warning">*</b></b>
                      <div class="form-field-right">
                        <input pInputText id="organisation" formControlName="organisation" autocomplete="off" class="w-100" [readonly]="true" />
                      </div>
                    </div>

                    <div class="form-row">
                      <b for="category" class="form-label-left">Category<b class="text-warning">*</b></b>
                      <div class="form-field-right">
                        <p-dropdown [options]="categoryOptions" formControlName="category" optionLabel="label"
                          optionValue="value" placeholder="-- Select Category --" class="w-100" [readonly]="true">
                        </p-dropdown>
                      </div>
                    </div>
                    <div class="form-row">
                      <b for="release_datex" class="form-label-left">Release Date</b>
                      <div class="form-field-right">
                        <input pInputText id="release_date" type="date" class="form-control"
                          formControlName="release_date" [readonly]="true" />
                      </div>
                    </div>
                    <div class="form-row">
                      <b for="technology_domain" class="form-label-left">Technology Domain<b
                          class="text-warning">*</b></b>
                      <div class="form-field-right">
                        <input pInputText id="technology_domain" formControlName="technology_domain" autocomplete="off" class="w-100" [readonly]="true" />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="collapsible-section">
                  <div class="collapsible-header" (click)="toggleSection('problem')">
                    <h3 class="section-title">
                      Problem Statement
                      <i class="pi ms-2"
                        [ngClass]="expandedSections['problem'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                    </h3>
                  </div>

                  <div class="collapsible-body" *ngIf="expandedSections['problem']">
                    <div class="form-row">
                      <b for="problem_statement" class="form-label-left">Problem Statement<b
                          class="text-warning">*</b></b>
                      <div class="form-field-right">
                        <input pInputText id="problem_statement" formControlName="problem_statement" autocomplete="off" class="w-100" [readonly]="true" />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="collapsible-section">
                  <div class="collapsible-header" (click)="toggleSection('detailedInformation')">
                    <h3 class="section-title">
                      Detailed Information
                      <i class="pi ms-2"
                        [ngClass]="expandedSections['detailedInformation'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                    </h3>
                  </div>

                  <div class="collapsible-body" *ngIf="expandedSections['detailedInformation']">
                    <div class="editor-field">
                      <b class="form-label-left">Challenge Brief/ Definition</b>
                      <editor [init]="init" formControlName="challenge_brief"></editor>
                    </div>
                    <div class="editor-field">
                      <b class="form-label-left">Future Expectation from the prototype development</b>
                      <editor [init]="initReadonly" formControlName="prototype_development"></editor>
                    </div>
                  </div>
                </div>

                <div class="collapsible-section mt-3">
                  <div class="collapsible-header" (click)="toggleSection('uploadChallengeDocs')">
                    <h3 class="section-title">
                      Document Uploads
                      <i class="pi ms-2" [ngClass]="expandedSections['uploadChallengeDocs'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                    </h3>
                  </div>

                  <div class="collapsible-body" *ngIf="expandedSections['uploadChallengeDocs']">
                    <app-upload-document [isEditable]="true" [dmsFiles]="selectedDraftProposal?.dms_files||[]" [isSaveVied]="true"></app-upload-document>
                  </div>
                </div>
            </div>
          </div>

          
          
          <!-- === Collapsible Section Template Example === -->
          <div class="form-section">
            <div class="section-header" (click)="toggleSection('basicInfo')">
              <h3 class="section-title">
                Basic Information
                <i class="pi" [ngClass]="expandedSections['basicInfo'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
              </h3>
            </div>
            <div class="section-content" *ngIf="expandedSections['basicInfo']">
              <div class="form-grid">
                <div class="form-field full-width">
                  <label for="valuation">IP Valuation<span class="required-asterisk">*</span></label>
                  <p-dropdown inputId="valuation" [options]="priorityOptions" formControlName="valuation"
                    optionLabel="label" optionValue="value" placeholder="Select IP Value"
                    [autoDisplayFirst]="false" appendTo="body" ></p-dropdown>
                </div>
              </div>
            </div>
          </div>
          <!-- === Rich Text Editors Section === -->
          <div class="form-section">
            <div class="section-header" (click)="toggleSection('detailedInfo')">
              <h3 class="section-title">
                Detailed Information
                <i class="pi" [ngClass]="expandedSections['detailedInfo'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
              </h3>
            </div>

            <div class="section-content" *ngIf="expandedSections['detailedInfo']">
              <div class="editor-field" [class.readonly-editor]="isEditorDisabled">
                <label>IP Value</label>
                <editor [init]="init" formControlName="ipValue" [disabled]="isEditorDisabled"></editor>
              </div>
            </div>
          </div>
        </div>
        <!-- Section A: Nodal Agency Details -->

        <!-- <div class="card mb-4">
          <div class="card-body">
            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label">IP Valuation</label>
                <p-dropdown [options]="priorityOptions" appendTo="body" formControlName="valuation" optionLabel="label"
                  optionValue="value" placeholder="-- Select IP Value --" class="w-100">
                </p-dropdown>
              </div>
            </div>
          </div>
        </div> -->

        <!-- Section B: Problem Statement -->
        <!-- Additional sections in accordion for better organization -->
        <!-- <div class="card mb-4">
          <div class="card-body">
            <div class="rich-text-section" [class.readonly-editor]="isEditorDisabled">
              <label class="form-label">• IP Value</label>
              <editor [init]="init" formControlName="ipValue" [disabled]="isEditorDisabled"></editor>
            </div>
            <div class="accordion mb-3" id="challengeDetailsAccordion">
              <div class="accordion-item">
                <div id="additionalDetails" class="accordion-collapse collapse">
                  <div class="accordion-body">
                    <div class="rich-text-section" [class.readonly-editor]="isEditorDisabled">
                      <label class="form-label">• IP Value</label>
                      <editor [init]="init" formControlName="ipValue" [disabled]="isEditorDisabled"></editor>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div>
        </div>
        <!-- <div>
          <ng-container *ngIf="needGenData?.pds">
          <h3 class="mt-4">Uploaded PDS Document</h3>
          <ul>
            <li><a href="{{ apiUrl + needGenData?.pds}}" target="_blank"
                                rel="noopener noreferrer">{{getFileName(needGenData?.pds)}}</a></li>
          </ul>
          </ng-container>

          <label
            for="draftSotr"
            *ngIf="
              stepDetails?.is_initiator ||
              stepDetails?.is_approver ||
              stepDetails?.is_recommender ||
              (stepDetails?.step_status != 'approved' && userID == 6)
            "
            >Upload PDS Document</label
          >
          <p-fileUpload
            name="draftSotr"
            #draftSotrUpload
            [auto]="true"
            [customUpload]="true"
            [multiple]="false"
            mode="advanced"
            [maxFileSize]="209715200"
            accept=".pdf,.doc,.docx,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            (uploadHandler)="onUploadDraftSotr($event)"
            *ngIf="
              stepDetails?.is_initiator ||
              stepDetails?.is_approver ||
              stepDetails?.is_recommender ||
              (stepDetails?.step_status != 'approved' && userID == 6)
            "
          >
            <ng-template #empty>
              <div>Drag and drop the document here to upload.</div>
            </ng-template>
          </p-fileUpload>

          <ng-container *ngIf="needGenData?.pru">
          <h3 class="mt-4">Uploaded PRU Document</h3>
          <ul>
                        <li><a href="{{ apiUrl + needGenData.pru}}" target="_blank"
                                rel="noopener noreferrer">{{getFileName(needGenData.pru)}}</a></li>
                    </ul>
          </ng-container>

          <label
            for="supportingDocs"
            class="mt-2"
            *ngIf="
              stepDetails?.is_initiator ||
              stepDetails?.is_approver ||
              stepDetails?.is_recommender ||
              (stepDetails?.step_status != 'approved' && userID == 6)
            "
            >Upload PRU Document</label
          >
          <p-fileUpload
            name="supportingDocs"
            #fileUpload
            [customUpload]="true"
            [multiple]="true"
            mode="advanced"
            (uploadHandler)="onUploadSupportingDocs($event)"
            [auto]="true"
            *ngIf="
              stepDetails?.is_initiator ||
              stepDetails?.is_approver ||
              stepDetails?.is_recommender ||
              (stepDetails?.step_status != 'approved' && userID == 6)
            "
            [maxFileSize]="209715200"
            accept=".pdf,.doc,.docx,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          >
            <ng-template #empty>
              <div>Drag and drop document here to upload.</div>
            </ng-template>
          </p-fileUpload>
        </div> -->
      </form>
    </ng-container>
  </div>
</div>